"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _lodash = require("lodash");
var _reactIntl = require("react-intl");
var _ui = require("@unite-us/ui");
var _addresses = _interopRequireDefault(require("../../utils/addresses"));
var _groups = _interopRequireDefault(require("../../utils/groups"));
var _Locations = _interopRequireDefault(require("../../locations/Locations"));
var _components = require("./components");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var ProviderDetailsV2 = function ProviderDetailsV2(props) {
  var center = props.center,
    className = props.className,
    clickableAddress = props.clickableAddress,
    initiallyCollapsed = props.initiallyCollapsed,
    openLink = props.openLink,
    provider = props.provider,
    providerLocations = props.providerLocations,
    showMore = props.showMore,
    title = props.title,
    intlProvider = props.intlProvider;
  var originLatLng = [center.lat, center.lng];
  var calculatedDistances = providerLocations.map(function (address) {
    return _addresses["default"].calculateDistance(address, originLatLng);
  });
  var locationsByDistance = (0, _lodash.sortBy)(calculatedDistances, function (add) {
    return add.distanceVal;
  }) || [];
  var isInNetworkGroup = _groups["default"].isInNetworkGroup(provider);
  var titleText = !(0, _lodash.isEmpty)(intlProvider) ? /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "LKNMNm",
    description: "about-header",
    defaultMessage: "About"
  }, function (txt) {
    return /*#__PURE__*/_react["default"].createElement("div", null, txt);
  }) : title;
  return /*#__PURE__*/_react["default"].createElement(_reactIntl.IntlProvider, {
    defaultLocale: "en",
    locale: intlProvider.locale,
    messages: intlProvider.messages
  }, /*#__PURE__*/_react["default"].createElement(_ui.Card, {
    className: (0, _classnames["default"])('provider-details mb-one', className)
  }, /*#__PURE__*/_react["default"].createElement(_ui.CardHeader, {
    className: "provider-details__header",
    title: titleText
  }), /*#__PURE__*/_react["default"].createElement(_ui.CardText, null, initiallyCollapsed ? /*#__PURE__*/_react["default"].createElement(_ui.MoreOrLess, null, /*#__PURE__*/_react["default"].createElement(_components.ProviderDescription, {
    className: "provider-details__section",
    provider: provider,
    isInNetworkGroup: isInNetworkGroup,
    openLink: openLink,
    intlProvider: intlProvider
  }), !(0, _lodash.isEmpty)(providerLocations) && /*#__PURE__*/_react["default"].createElement(_ui.Divider, {
    className: "provider-details__divider"
  }), /*#__PURE__*/_react["default"].createElement(_Locations["default"], {
    className: "provider-details__section",
    clickableAddress: clickableAddress,
    isInNetworkGroup: isInNetworkGroup,
    locations: locationsByDistance,
    showMore: showMore,
    intlProvider: intlProvider
  })) : /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_components.ProviderDescription, {
    className: "provider-details__section",
    provider: provider,
    isInNetworkGroup: isInNetworkGroup,
    openLink: openLink,
    showMore: true,
    intlProvider: intlProvider
  }), !(0, _lodash.isEmpty)(providerLocations) && /*#__PURE__*/_react["default"].createElement(_ui.Divider, {
    className: "provider-details__divider"
  }), /*#__PURE__*/_react["default"].createElement(_Locations["default"], {
    className: "provider-details__section mb-one",
    clickableAddress: clickableAddress,
    isInNetworkGroup: isInNetworkGroup,
    locations: locationsByDistance,
    showMore: true,
    intlProvider: intlProvider
  })))));
};
ProviderDetailsV2.propTypes = {
  center: _propTypes["default"].shape({
    lat: _propTypes["default"].number,
    lng: _propTypes["default"].number
  }),
  className: _propTypes["default"].string,
  clickableAddress: _propTypes["default"].bool,
  provider: _propTypes["default"].object,
  initiallyCollapsed: _propTypes["default"].bool,
  openLink: _propTypes["default"].func,
  providerLocations: _propTypes["default"].array,
  showMore: _propTypes["default"].bool.isRequired,
  title: _propTypes["default"].string,
  intlProvider: _propTypes["default"].shape({
    locale: _propTypes["default"].string,
    messages: _propTypes["default"].array
  })
};
ProviderDetailsV2.defaultProps = {
  center: {
    lat: 0,
    lng: 0
  },
  className: '',
  clickableAddress: false,
  provider: {},
  initiallyCollapsed: true,
  openLink: window.open,
  providerLocations: [],
  title: 'About',
  intlProvider: {
    locale: 'en',
    messages: []
  }
};
var _default = exports["default"] = ProviderDetailsV2;